<template>
    <div class="serviceItem">
        <q-bar class="bg-white">
            <div class="col text-center">
                {{ $t('account.title') }}
            </div>
        </q-bar>

        <q-list bordered separator>
            <q-item v-for="(item, index) in items"
                    :key="index"
                    v-ripple
                    clickable
                    @click="goDetail(item)"
                    v-show="item.show">

                <q-item-section avatar>
                    <q-icon color="primary"
                            :name="`img:/icons/account.${item.key}.svg`" />
                </q-item-section>
                <q-item-section>
                    <q-item-label> {{ $t(`account.${item.key}`) }} </q-item-label>
                </q-item-section>
                <q-item-section side>
                    <i class="fas fa-chevron-right"></i>
                </q-item-section>
            </q-item>
        </q-list>

    </div>
</template>

<script>
    import { mapMutations } from 'vuex';
    export default {
        name: 'AccountIndex',
        data() {
            return {
                isMobile: false,
                items: [
                    {
                        key: 'personalInfo',
                        order: 0,
                        to: 'AccountPersonalInfo',
                        show: true,
                    },
                    {
                        key: 'takeRoomCard',
                        order: 1,
                        to: 'AccountTakeRoomCard',
                        show: false,
                    },
                    {
                        key: 'importReservation',
                        order: 2,
                        to: 'AccountImportReservation',
                        show: true,
                    },
                    {
                        key: 'sharingReservation',
                        order: 3,
                        to: 'AccountSharingReservation',
                        show: true,
                    },
                    {
                        key: 'acceptedSharingReservation',
                        order: 4,
                        to: 'AccountAcceptedSharingReservation',
                        show: true,
                    },
                    {
                        key: 'logout',
                        order: 5,
                        to: 'Login',
                        show: true,
                    },
                ],
            };
        },
        created() {
            this.detectDeviceType();
            this.showList();
        },
        methods: {
            ...mapMutations({
                logout: 'user/LOGOUT',
            }),
            goDetail(item) {
                if (item.key === 'logout') {
                    this.logout();
                }

                this.$router.push({ name: item.to });
            },
            detectDeviceType() {
                this.isMobile = this.$sharedMethod();
            },
            showList() {
                if (this.isMobile) {
                    this.items[2].show = false;
                    this.items[3].show = false;
                    this.items[4].show = false;
                    this.items[5].show = false;
                }
            },
        },
    };
</script>
